import React, { forwardRef, Fragment } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Label from '@polestar/component-warehouse-react/components/label/Label';
import Spacer from '@polestar/component-warehouse-react/components/spacer/Spacer';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import Sizes from '@polestar/component-warehouse-react/tokens/sizes/Sizes';
import Paragraph from '@polestar/component-warehouse-react/components/paragraph/Paragraph';
import Emphasis from '@polestar/component-warehouse-react/tokens/emphasis/Emphasis';
const Quote = forwardRef(({ children, author, highEmphasis = true, disableQuotes = false, ...props }, ref) => {
    const emphasis = highEmphasis ? Emphasis.medium : Emphasis.low;
    return (React.createElement(Container, { ...props, ref: ref },
        children && (React.createElement(Fragment, null,
            React.createElement(StyledText, { as: "blockquote", size: Sizes.large, emphasis: emphasis, disableQuotes: disableQuotes }, children),
            author !== '' && author !== undefined && React.createElement(Spacer, { spacing: Spacings.large }))),
        author !== undefined && author !== '' && (React.createElement(StyledNote, { as: "figcaption", emphasis: emphasis }, author))));
});
Quote.displayName = 'Quote';
export default Quote;
const Container = styled.figure `
  display: flex;
  flex-direction: column;
  text-align: start;
`;
const StyledText = styled(Paragraph)(({ theme, emphasis, disableQuotes }) => css `
    display: block;
    color: ${theme.quote.emphasis[emphasis].title.color};

    &:before {
      content: '${disableQuotes ? '' : '“'}';
    }

    &:after {
      content: '${disableQuotes ? '' : '”'}';
    }
  `);
const StyledNote = styled(Label)(({ theme, emphasis }) => css `
    display: block;
    color: ${theme.quote.emphasis[emphasis].note.color};
  `);
